import claimMessages from '@/modules/Claim/i18n/es'
import damageMessages from '@/modules/Damage/i18n/es'
import appointmentMessages from '@/modules/Appointment/i18n/es'
import documentMessages from '@/modules/Document/i18n/es'

export default {
  claim: { ...claimMessages },
  damage: { ...damageMessages },
  appointment: { ...appointmentMessages },
  document: { ...documentMessages },
  documentContainer: {
    title: 'Daños Inmobiliarios',
    upper1: 'Con el fin de tratar de la mejor manera su solicitud, le invitamos a enviarnos su presupuesto/factura siguiendo las instrucciones a continuación:',
    upper2: 'Si su presupuesto/factura cabe en una sola página, envíenoslo en formato pdf, jpg o png.',
    upper3: 'Si su presupuesto/factura contiene más de una página, agrupe todas las páginas en un solo archivo en formato pdf.',
    upper4: "Si dispone de varios presupuestos, cárguelos uno por uno haciendo clic en el botón a continuación. Una vez que todos los documentos estén cargados, haga clic en 'Continuar'."
  },
  // actions
  actions: {
    addDamage: 'Añadir',
    login: 'Login',
    select: 'Seleccionar',
    clear: 'Limpiar',
    continue: 'Continuar',
    cancel: 'Cancelar',
    import: 'Importar',
    export: 'Exportar',
    exportAll: 'Exportar todos',
    selectFile: 'Seleccionar fichero',
    search: 'Buscar',
    save: 'Guardar',
    delete: 'Eliminar',
    suppress: 'Suprimir',
    confirmAndContinue: 'Confirma y continua',
    confirmDommages: 'Validar daños',
    goBack: 'Volver atrás',
    addMoreDamage: 'Añadir daño',
    accept: 'Aceptar',
    confirmWithNoDamages: 'No he sufrido ningún daño, pasar al siguiente paso'
  },
  // common damages
  commonDamages: {
    emptyData: 'No se han especificado datos relacionados con este daño.'
  },

  // view: addDamages
  addDamages: {
    title: 'Cuéntanos más sobre los daños',
    buttonTitle: 'Añadir daños',
    buttonTitleFeature: 'Siguiente'
  },

  // view: multidamageList
  multidamageList: {
    delete: 'Suprimir',
    inputTitle: 'Por favor, indíquenos el tamaño de su habitación',
    inputTitleTest: 'Cuál es la superficie (aproximada)',
    inputHint: 'En metros cuadrados',
    btnContinue: 'Confirmar y continuar',
    btnAddDamage: 'Detallar estos daños',
    btnAddDamagePhotoclaim: 'Toma una foto del daño',
    btnAddDamageModal: 'Confirmar los daños',
    btnAddAllDamages: 'Siguiente',
    calculateSurfaceLink: {
      text1: '¿No sabes la superficie?',
      text2: 'Podemos ayudarle a calcularlo',
      link: 'Calcular la superficie'
    },
    calculateSurfaceModal: {
      title: 'Calcular el área',
      input1: '¿Cuántos pasos has contado a lo ancho de la habitación?',
      input2: '¿Cuántos pasos has contado a lo largo de la habitación?',
      inputErrorText: 'Debe ser un valor numérico mayor que 1',
      text: 'Para medir su habitación, necesitamos saber la anchura y la longitud. Para ello, le pedimos que se coloque en una esquina y, desde allí, recorra ambos lados y anote el número de pasos de la anchura y la longitud de su habitación.'
    },
    cameraFlow: {
      textCamera: 'Haz 3 fotos para evaluar correctamente los daños.',
      cameraBtn: 'Fotografiar la habitación',
      continuerBtn: 'Continuar',
      againBtn: 'Hacer de nuevo',
      cameraBtn2: 'Fotografiar los daños',
      noRequired: 'No incluir fotos',
      cameraDescription: 'Haz tres fotos de tus daños.',
      cameraDescription2: 'Asegúrese de que son correctos.',
      overallCamera: 'Panorama general'
    }
  },

  // view: damageMobilier
  damageMobilier: {
    search: {
      predictibles: 'Elija entre nuestras categorías más frecuentes:',
      containerInputs: 'Busca entre nuestras categorías',
      categoryList: 'Resultados de la búsqueda',
      containerEmptyTxt1: 'Su búsqueda',
      containerEmptyTxt2: 'no consiguió',
      containerEmptyTxt3: 'resultados'
    },
    category: {
      inputTextError: 'Campos obligatorios: valor numérico',
      modal1: 'Antes de continuar',
      modal2: 'Compruebe que estos datos sean correctos:',
      date: 'Fecha de compra',
      price: 'Precio de compra',
      buttonsNextActionsTitle: 'Sí, eso es correcto',
      buttonsNextActionsTitleWhiteBtn: 'No, editar'
    },
    damageResultUptec: {
      title: 'La valoración de su daño se realizará utilizando este modelo:'
    }
  },

  // view: damageItems
  damagedItems: {
    buttonTitle: 'Siguiente',
    defaultTitle: '¿Qué partes se vieron afectadas?',
    defaultText: ''
  },

  // view: damagedParts
  damagedParts: {
    buttonTitle: 'Siguiente',
    selectParts:
      'Indicar las superficies afectadas o si es necesario realizar una limpieza.',
    multidamageDescription:
      'Seleccione todas las partes afectadas por el daño.',
    defaultText: '',
    defaultTextExternalDamage: '¿Cuál es el elemento dañado?'
  },

  // view: damageDetails
  damageDetails: {
    surfaceSmallText: 'En metros cuadrados',
    titleFileInputEnsemble:
      'Fotos de conjunto - Por favor, sitúese lo más lejos posible de los daños',
    titleFileInputPres:
      'Fotos de cerca - Por favor, acérquese lo más posible a los daños',
    errorPhoto:
      'Adjunta la foto en formato .png o .jpg o .jpeg. No mayor a 6MB.'
  },

  // view: damagesConfirmed
  damagesConfirmed: {
    titleDamagesConfirmed: 'Resumen de daños',
    photosEnsemble:
      'Fotos de conjunto - Por favor, sitúese lo más lejos posible de los daños',
    photosPres:
      'Fotos de cerca - Por favor, acérquese lo más posible a los daños'
  },

  // component: furniture
  furniture: {
    title: 'Contenido',
    empty: {
      short: 'Falta referencia de siniestro',
      long: 'Para poder añadir daños del contenido, introduzca referencia del siniestro'
    },
    kindOfProperty: 'Tipo de propiedad',
    kindOfPropertyOptions: {
      owner: 'Propietario',
      renter: 'Inquilino'
    }
  },
  // component: warrantySticky
  warrantySticky: {
    materialListBtn: 'Lista de material'
  },
  // notification
  notifications: {
    error: {
      0: {
        title: 'No se acepta el código postal que ingresó anteriormente',
        body: 'Ha ocurrido un error al realizar la acción'
      },
      400: {
        title: 'Faltan campos',
        body: 'Revise los campos del formulario'
      },
      500: {
        title: 'Error',
        body: 'Ha ocurrido un error'
      },
      409: {
        title: 'Error de identificador',
        body: 'El siniestro ya existe'
      },
      title: 'No se acepta el código postal que ingresó anteriormente',
      body: 'Ha ocurrido un error al realizar la acción'
    },
    addDamage: {
      title: 'Daño creado',
      body: 'El daño se ha creado correctamente'
    },
    newSinister: {
      title: 'Nuevo siniestro',
      body: 'Ha cambiado la identificación del siniestro'
    },
    deleteDamage: {
      title: 'Daño eliminado',
      body: 'El daño se ha eliminado correctamente'
    },
    pdfDamages: {
      title: 'Informe creado',
      body: 'El informe se ha generado correctamente'
    },
    pdfMaterial: {
      title: 'Informe creado',
      body: 'El informe se ha generado correctamente'
    },
    mailPdfMaterial: {
      title: 'Email enviado',
      body: 'El email se ha enviado correctamente',
      error: {
        title: 'Email no válido',
        body: 'Introduce un email correcto'
      }
    },
    moCalculation: {
      title: 'Precio actualizado',
      body: 'Recargando informe'
    },
    changeLanguage: {
      title: 'Cambio de idioma',
      body: 'Redirigiendo'
    },
    loadSinisterOK: {
      title: 'Siniestro cargado',
      body: 'Actualizando información'
    },
    loadSinisterKO: {
      title: 'Error de siniestro',
      body: 'Error al cargar el siniestro'
    },
    paramChanged: {
      title: 'Parámetro cambiado',
      body: 'La tabla se actualizará automáticamente'
    },
    user: {
      isRequired: {
        title: 'Faltan campos',
        body: 'Por favor, complete correctamente todos los campos'
      },
      isEmail: {
        title: 'Email erróneo',
        body: 'El email introducido no es válido'
      },
      isSamePassword: {
        title: 'Repite contraseña',
        body: 'Las contraseñas no coinciden'
      },
      createdUser: {
        title: 'Usuario creado',
        body: 'Actualizando vista'
      },
      modifiedUser: {
        title: 'Usuario modificado',
        body: 'Actualizando vista'
      },
      deletedUser: {
        title: 'Usuario eliminado',
        body: 'Actualizando vista'
      },
      error: {
        400: {
          title: 'Faltan campos',
          body: 'Revise los campos del formulario'
        },
        500: {
          title: 'Error',
          body: 'Ha ocurrido un error'
        },
        409: {
          title: 'Error de identificador',
          body: 'El usuario ya existe'
        }
      }
    },
    images: {
      uploadError: {
        title: 'Error de subida',
        text: 'Adjunte la foto en formato .png o .jpg o .jpeg. No más de 6 MB.'
      },
      inputImgError: {
        title: 'Error de subida',
        text: 'Se ha producido un error al subir la foto. Puede continuar sin añadir fotos'
      },
      postImgError: {
        title: 'Error de subida',
        text: 'Se ha producido un error al subir la foto.'
      }
    }
  },

  // datePicker
  datePicker: {
    literal: 'Fecha de compra'
  },

  // damagesTypes view
  damagesTypes: {
    titleNavbar: '¿Cual es el origen de sus daños?'
  },

  // damageMobilierUptecFeature
  damageMobilierUptecFeature: {
    inputTxtValue: 'Indique la marca y el modelo'
  },

  // damageValidation
  damageValidation: {
    title: 'Daños inmobiliarios',
    subtitle: 'Con base en la información proporcionada, podemos ofrecer una base de indemnización inmediata de',
    text1: 'Solución: Realizar las reparaciones yo mismo',
    text2: 'Según la descripción de sus daños, le proponemos la siguiente indemnización inmediata:',
    text3: 'Si acepta esta indemnización, la recibirá en la cuenta bancaria utilizada para el pago de sus cotizaciones o mediante cheque.',
    text4: 'Si rechaza esta indemnización, un asesor de Allianz se pondrá en contacto con usted en un plazo de 48 horas*.',
    text5: '*Horas laborales y salvo problemas excepcionales o fuera de nuestro control.',
    modal: {
      title: 'Cómo se calcula esta indemnización',
      subtitle: 'La indemnización de mutuo acuerdo que recibirá por sus daños inmobiliarios se calcula en base al coste total de reparación. Este coste total es la base de la indemnización e incluye los costes de materiales, alquiler de herramientas y una compensación por el tiempo dedicado a la reparación. \nSi su contrato prevé una franquicia, esta se deducirá del importe de la indemnización. \n\n La indemnización puede abonarse por transferencia bancaria en los plazos habituales con su IBAN, o mediante cheque bancario.',
      button: 'Aceptar',
      close: 'Cerrar'
    },
    accordion: {
      title: 'Daños declarados y método de cálculo',
      base: 'Base de indemnización',
      details: 'Detalle de la indemnización',
      calcCompensation: '¿Cómo se calcula esta indemnización?'
    },
    amount: '{amount} €',
    actions: {
      primary: 'Sí, acepto la compensación propuesta',
      secondary: 'Me gustaría discutir esta valoración con un asesor.',
      tertiary: 'No, quería otra solución.'
    },
    materialsList: 'Lista de materiales',
    upptecDossier: 'Informe Contenido',
    mobilier: {
      title: 'Daños a mobiliario',
      solution: 'Solución:',
      text1: 'Recibir una indemnización inmediata',
      text2: 'Según la descripción de sus daños, le proponemos la siguiente indemnización inmediata:',
      text3: 'Si acepta esta indemnización, la recibirá en la cuenta bancaria utilizada para el cobro de sus cuotas o mediante cheque.',
      text4: 'Si rechaza esta indemnización, un asesor de Allianz se pondrá en contacto con usted en un plazo de 48 horas*.',
      text5: '*Horas hábiles y salvo problemas excepcionales o fuera de nuestro control.',
      age: 'Edad (en años):',
      actions: {
        primary: 'Aceptar esta indemnización',
        secondary: 'Rechazar esta indemnización'
      }
    }
  },
  damageFraisValidation: {
    title: 'Gastos relacionados con el siniestro',
    solution: 'Solución:',
    text: 'Recibir un reembolso con justificante',
    text1: 'Según la descripción de los gastos que ha incurrido, le proponemos la siguiente indemnización con justificante:',
    text2: 'Si acepta esta indemnización, deberá enviarnos sus justificantes directamente desde su Espacio Cliente.',
    text3: 'Si rechaza esta indemnización, un asesor de Allianz se pondrá en contacto con usted en un plazo de 48 horas*.',
    text4: '*Horas laborables y salvo problemas excepcionales o independientes de nuestra voluntad.',
    actions: {
      primary: 'Aceptar esta indemnización',
      secondary: 'Rechazar esta indemnización'
    }
  },
  // common
  common: {
    surface: 'Superficie',
    line: 'Línea',
    distance: 'Distancia',
    actualCalc: 'Cálculo en curso',
    selectOnTheMap: 'Seleccione sobre el mapa para medir',
    mapAction: 'Medir en el mapa',
    min: 'Mínimo',
    max: 'Máximo',
    total: 'Total',
    recommended: 'Recomendado',
    standard: 'Estándar',
    noFile: 'Ningún fichero seleccionado',
    email: 'Correo electrónico',
    search: 'Búsqueda',
    results: 'Resultados',
    noresults: {
      short: 'No hay resultados',
      long: 'No se encontraron resultados para tu búsqueda'
    },
    true: 'Sí',
    false: 'No',
    noOptions: 'No hay opciones',
    noSelected: 'Ninguno seleccionado',
    agentView: 'Vista agente',
    managerView: 'Vista tramitador',
    unit: '0 unidades | x {count} unidad | x {count} unidades'
  },

  // view: error
  errorView: {
    title: 'Se ha producido un error',
    text: 'Nuestro equipo está trabajando para resolver el problema lo más rápido posible.'
  },

  timedoutView: {
    title: 'El link ha caducado',
    text: {
      upper: `Lo sentimos, pero el enlace ha caducado y ya no es válido`,
      lower: `Póngase en contacto con nuestros operadores para obtener un nuevo enlace`
    }
  },

  // cart
  cart: {
    title: 'Lista de daños introducidos'
  },

  // component: form-container
  formContainer: {
    mursTitle: 'Número de paredes afectadas'
  },

  // component: customImage
  customImageInput: {
    default: {
      takeScreenshot: 'Encuadra el daño',
      repeat: 'Repetir',
      usePhoto: 'Usar foto'
    },
    guideCamera: {
      takeScreenshot: 'Encuadra el daño en la {guideIndexLiteral} guía',
      first: 'primera',
      second: 'segunda',
      third: 'tercera'
    },
    cornersCamera: {
      takeScreenshot:
        'Depuis le centre de la pièce, photographiez chaque recoin',
      endPhotos: 'Finaliser'
    }
  },
  otpView: {
    title: 'Hola',
    text: {
      upper: `Bienvenido a su espacio "Mis daños", que le permite describir la totalidad de sus daños.`,
      upper2: `Para acceder, ingrese el código enviado a su teléfono en `,
      upper3: `Este paso puede tardar hasta 2 minutos.`,
      lower1: `Por favor ingrese su código de verificación.`,
      lower2: `Se ha enviado un código a su teléfono en `,
      nocode: `¿No recibiste tu código?`,
      resend: 'Reenviar un SMS',
      resendNotification: 'Mensaje reenviado',
      errorNotification: 'Codigo erroneo',
      popup: {
        text1: `Si no ha recibido el código de autenticación, le recomendamos estos tres pasos : `,
        list1_1: `Compruebe que el número de teléfono`,
        list1_2: `coincide con el tuyo`,
        list2: `Si el número coincide, cierre esta ventana y haga clic en "Reenviar SMS"`,
        list3: `Si el número no corresponde, lo invitamos a ingresarlo en su `,
        link1: `Espacio cliente`,
        text2: `Un asesor de Allianz le devolverá la llamada en un plazo de 24 horas.`,
        bpce: {
          text3: 'Si el número no se corresponde, póngase en contacto con su asesor BPCEAI.'
        }
      }
    },
    bpce: {
      title: 'Hola',
      upper1: 'Su presupuesto/factura será procesado por nuestro equipo, nos pondremos en contacto con usted a la brevedad posible.'
    }
  },
  // legal conditions
  cookiesAndLegal: {
    general: {
      title: 'Términos y Condiciones',
      paragraph1: `Antes de comenzar, revise nuestro uso de cookies en su navegador y nuestros términos y condiciones de servicio. Al hacer clic en el botón Aceptar, confirma que ha leído y comprendido las condiciones relativas a este servicio.`
    },
    cookies: {
      title: 'POLÍTICA DE COOKIES',
      paragraph1: {
        list1: `A continuación, se le mostrará la Política de Cookies (en adelante, “la Política de Cookies” o “la Política”) que rige la Plataforma Web https://mavalue.plataforma-smart.com/ (en adelante, “la Plataforma” , o “MAValue”), titularidad de Multiassistance, S.A. (en adelante, “Multiassistance” o “nosotros”).`,
        list2: `La presente Política de Cookies tiene como finalidad ayudarle a comprender el uso que se hace en esta plataforma web de las cookies, sus tipos, su finalidad y su duración, así como indicarle las opciones que tiene para configurarlas, administrarlas o no estos.`,
        list3: `POR FAVOR TÓMESE UNOS MINUTOS PARA LEER NUESTRA POLÍTICA DE COOKIES, NO LE LLEVARÁ MUCHO TIEMPO. QUEREMOS EXPLICAR DE UNA MANERA SENCILLA, CLARA Y TRANSPARENTE CÓMO PROCESAMOS Y PROTEGEMOS SU INFORMACIÓN PERSONAL Y SUS DERECHOS. SU SEGURIDAD Y LA DE SUS DATOS PERSONALES ES FUNDAMENTAL PARA NOSOTROS Y NOS TOMAMOS MUY EN SERIO SU ADECUADA PROTECCIÓN.`,
        list4: `TAMBIÉN LE RECOMENDAMOS LEER NUESTRA POLÍTICA DE PRIVACIDAD.`
      },
      paragraph2: {
        title: `¿Qué son las cookies?`,
        body: `Las cookies son pequeños archivos o pequeños dispositivos que se descargan y almacenan en su terminal (es decir, el dispositivo desde el que accede a la Plataforma: ordenador, teléfono móvil, tableta o cualquier otro dispositivo conectado…) y que permiten a la Plataforma o al sitio web recordar información relativa a Tu visita.
        Las cookies pueden ser de diferentes tipos en función de varios parámetros:`,
        list1: `Según quien sea la entidad que gestione el equipo o dominio desde donde se envían las cookies y trate los datos que se obtengan, podemos distinguir los siguientes:`,
        list2: `Cookies propias: son aquéllas que se envían al equipo terminal del usuario desde un equipo o dominio gestionado por Multiassistance y desde el que se presta el servicio solicitado por el usuario.`,
        list3: `Cookies de terceros: son aquéllas que se envían al equipo terminal del usuario desde un equipo o dominio no gestionado por Multiassistance, sino por otra entidad que trata los datos obtenidos a través de las cookies. Cuando las cookies se instalan desde un equipo o dominio gestionado por Multiasistencia, pero la información recogida por los mismos es gestionada por un tercero, no pueden considerarse cookies propias de Multiasistencia. En este sentido, Multiassistance podrá utilizar los servicios de empresas de análisis y medición para medir y/o analizar el comportamiento de navegación de los usuarios en la plataforma, y, en este sentido, que actúen en su nombre y representación, con motivo de la análisis de los datos obtenidos por el uso de las cookies de estos servicios, todo ello con el objetivo de mejorar el servicio prestado por Multiassistance.`,
        list4: `Según la finalidad para la que se traten los datos obtenidos a través de las cookies, podemos distinguir entre:`,
        list5: `Cookies técnicas: Son aquéllas que permiten al usuario la navegación a través de la plataforma y la utilización de las diferentes opciones o de los diferentes servicios disponibles en la misma como, por ejemplo, el control del tráfico y comunicación de datos, identificación de la sesión, acceso a datos de acceso, recordatorio de los elementos que constituyen una solicitud de inscripción o participación en un evento, la utilización de elementos de seguridad durante la navegación, el almacenamiento de contenidos para la difusión de vídeos o sonido o la compartición de contenidos en redes sociales.`,
        list6: `Cookies de personalización: Son aquéllas que permiten al usuario acceder al servicio con algunas características de carácter general predefinidas en función de una serie de criterios en el terminal del usuario como por ejemplo serian el idioma, el tipo de navegador a través del cual accede al servicio, la configuración regional para acceder al servicio, entre otros.`,
        list7: `Cookies de análisis: Son aquéllas que permiten a su responsable, el seguimiento y análisis del comportamiento de los usuarios de los sitios web a los que están vinculadas. La información recogida mediante este tipo de cookies se utiliza para medir la actividad en la plataforma y para la elaboración de perfiles de navegación de los usuarios en los sitios en cuestión, en las aplicaciones y en las plataformas con vistas a introducir mejoras: en base a la análisis de los datos consultados por los usuarios del servicio.`,
        list8: `Cookies publicitarias: Son aquéllas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso, el editor haya incluido en una página web, aplicación o plataforma desde la que prestará el servicio solicitado. proporcionarse en función de criterios como el contenido editado o la frecuencia de visualización de los anuncios.`,
        list9: `Cookies de publicidad comportamental: Son aquéllas que permiten la gestión, de la forma más eficaz posible, los espacios publicitarios que, en su caso, el editor haya incluido en una página web, aplicación o plataforma desde la que presta el servicio solicitado. previsto. Estas cookies almacenan información del comportamiento de los usuarios que se ha obtenido a través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico en base a ello.`,
        list9_1: `Dependiendo del periodo de tiempo en el que están activas dentro del equipo terminal (temporalidad), podemos distinguir las siguientes:`,
        list10: `Cookies de sesión: Son cookies diseñadas para recabar y almacenar datos durante el acceso del usuario a la plataforma.`,
        list11: `Cookies persistentes: Son aquéllas en las que los datos siguen guardados en el terminal y que pueden ser tratados durante un periodo de tiempo definido por el responsable de la cookie, y que puede variar de unos minutos a varios años.`,
        footer: `Puede consultar la información sobre cookies y otros rastreadores proporcionada por la Comisión Nacional de Informática y Libertades (CNIL) haciendo clic aquí.`
      },
      paragraph3: {
        title: `¿Qué cookies se utilizan en la plataforma?`,
        body: `Esta plataforma utiliza cookies técnicas necesarias para permitir y optimizar la navegación del usuario y la funcionalidad de la plataforma.
        Las cookies utilizadas son necesarias para permitir la navegación en la Plataforma y asegurar su correcto funcionamiento, por lo que no pueden ser rechazadas por el usuario y la desactivación o cancelación de las mismas supondrá la imposibilidad de utilizar la Plataforma.
        A continuación se identifican las cookies utilizadas dentro de esta Plataforma: `,
        list1: `Cookie`,
        list1_1: `mavalue.plataforma-smart`,
        list2: `Objetivo`,
        list2_1: `Cookie para permitirle permanecer conectado`,
        list3: `Administración`,
        list3_1: `Propio`,
        list4: `Duración`,
        list4_1: `1 año `
      },
      paragraph4: {
        title: `Actualizaciones y cambios en la Política de Cookies.`,
        body: `Esta Política de Cookies puede modificarse en función de exigencias legislativas, reglamentarias o con la finalidad de adaptar dicha política a las instrucciones dictadas por la Comisión Nacional de Informática y Libertades (CNIL), en este sentido, se aconseja a los usuarios que la consulten periódicamente.`
      }
    },
    legal: {
      title: 'NOTAS LEGALES',
      paragraph1: {
        list1: `El acceso a las soluciones digitales ya todas las funcionalidades contenidas en esta Plataforma están incluidos en los servicios contratados por la empresa titular del derecho de uso de las mismas (la empresa), en cuyo número adquiere usted la condición de usuario de las mismas. El acceso, navegación y uso de la Plataforma implica satisfacer la condición de usuario de la misma (en adelante, “el usuario”) y, por tanto, suscribir la aceptación expresa y sin reservas por parte del usuario de todos los términos y condiciones contenidos en este Aviso Legal. Aviso, por lo que recomendamos su lectura atenta, de forma que, en caso de disconformidad, bastará con no aceptarlo por los medios previstos al efecto, imposibilitando la utilización de la Plataforma, los servicios y las funciones establecidas. a través de este último ultimo.`
      },
      paragraph2: {
        title: `INFORMACIÓN GENERAL.`,
        subParagraph1: {
          title: `EDITOR`,
          line1: `MULTIASSISTANCE, S.A. (en adelante, «Multiassistance» o «nosotros»);`,
          line2: `Sociedad anónima con capital de 48.494,10 euros`,
          line3: `146 boulevard de Charonne`,
          line4: `75020 Paris`,
          line5: `Número de identificación del IVA intracomunitario: FR 62413114901`,
          line6: `Nombre del Director de la publicación: D. Íñigo Astarloa Echevarrieta`,
          line7: `Tel : 01 40 09 36 60`,
          line8: `Email : info@multiasistencia.com; contact.clients@Multiassistance.com `
        },
        subParagraph2: {
          title: `ANFITRIÓN`,
          line1: `Amazon Web Services EMEA SARL`,
          line2: `38 avenue John F Kennedy, L-1855 Luxembourg`,
          line3: `Fax: 352 2789 0057`
        }
      },
      paragraph3: {
        title: `PLATAFORMA WEB: USO, FINALIDAD Y RÉGIMEN JURÍDICO APLICABLE.`,
        list1: `Multiassistance es una empresa especializada en la gestión y reparación de siniestros de seguros de hogar y comercio para compañías de seguros y, como parte de esta actividad, pone a disposición de sus clientes soluciones digitales orientadas a optimizar y digitalizar sus procesos operativos.`,
        list2: `La Plataforma es el canal a través del cual los usuarios autorizados pueden utilizar las distintas soluciones que hayan contratado o que tenga contratada la empresa a la que pertenecen o con la que mantienen una relación de colaboración.`,
        list3: `El acceso a las soluciones digitales ya todas las funcionalidades contenidas en esta Plataforma están incluidos en los servicios contratados por la empresa titular del derecho de uso de las mismas (la empresa), en cuyo nombre adquiere usted la condición de usuario de las mismas. El acceso y uso de la Plataforma implica la aceptación de todas las presentes condiciones, así como cualesquiera otras que puedan establecerse, modificarse y/o ampliarse en función de determinadas necesidades presentes o futuras del Servicio. Multiasistencia podrá modificar en cualquier momento el contenido de las presentes condiciones así como los servicios y funcionalidades establecidos en la Plataforma, entendiéndose que bastará con la publicación de dichos cambios y modificaciones por este medio de comunicación, sin que ello sin perjuicio de la posibilidad del usuario de aceptar o no las modificaciones en cuestión. En caso de no aceptación, podría tener como consecuencia la imposibilidad de utilizar la Plataforma para todas o algunas de las funcionalidades estipuladas por ésta.`
      },
      paragraph4: {
        title: ` CONDICIONES DE ACCESO Y USO.`,
        body1: `El usuario se obliga a hacer un uso adecuado y lícito de la Plataforma, así como de los contenidos, productos y servicios que desde ella se establezcan, de conformidad con la legislación aplicable en cada momento, con las presentes condiciones, en el sentido de la moral y las buenas costumbres generalmente aceptadas. los hábitos y el orden público. `,
        body2: `Asimismo, el usuario de la Plataforma se compromete a lo siguiente:`,
        list1: `Garantizar la autenticidad, veracidad, actualidad y exactitud de todos aquellos datos que comunique a través de la Plataforma, precisando que en caso contrario será el usuario el único responsable.`,
        list2: `Utilizar la Plataforma exclusivamente para los fines y funcionalidades acordadas por Multiassistance, quedando por tanto prohibido al usuario utilizar la Plataforma para cualquier otro fin o cualquier otro medio.`,
        list3: `Hacer un uso lícito y legítimo de la Plataforma, evitando cualquier uso no autorizado, fraudulento, ilegal o ilegítimo de la misma y/o de los contenidos e información establecidos por ella, evitando ir en contra de los presentes Avisos Legales así como de la normativa aplicable, vulnerar los derechos e intereses legítimos de Multiassistance o de cualquier otro tercero que pueda verse afectado por esta actuación.`,
        list4: `No provocar daños en los sistemas físicos o lógicos de la Plataforma, de sus proveedores o de terceras personas; no intentar vulnerar las medidas de seguridad o autenticación de las mismas, no realizar acciones que provoquen una saturación desproporcionada o innecesaria de la infraestructura o del entorno de comunicaciones relativas a la Plataforma y al Servicio, atentando contra éste de una forma u otra. Multiasistencia podrá implementar cualquier medida preventiva o correctiva que considere necesaria para proteger sus intereses de acuerdo con el correcto funcionamiento de la Plataforma, el Servicio y las funcionalidades especificadas.`,
        list5: `No introducir ni difundir en la red virus informáticos o cualquier otro sistema físico o lógico que pueda causar daños tales como virus, códigos maliciosos o cualquier otro programa o archivo dañino.`,
        list6: `No intente acceder, usar y/o manipular datos o cualquier otra información que sea procesada por la Plataforma.`,
        list7: `En particular, ya título meramente informativo y no taxativo, el usuario se compromete a no transmitir, difundir o poner a disposición de terceros informaciones, datos, contenidos o mensajes que puedan vulnerar derechos de Multiasistencia o de terceros.`,
        list8: `No acceder sin autorización o utilizar una identidad falsa, suplantar la identidad de terceros o utilizar un perfil o realizar cualquier otra acción que pueda generar confusión o inducir a error sobre la correcta identidad del usuario de que se trate.`
      },
      paragraph5: {
        title: `PROPIEDAD INDUSTRIAL E INTELECTUAL.`,
        list1: `El usuario reconoce y acepta que todos los derechos de propiedad intelectual e industrial sobre la Plataforma y todos sus elementos asociados corresponden a Multiassistance o a terceros que hayan autorizado expresamente a Multiassistance a tal efecto.`,
        list2: `En ningún caso el acceso o la navegación por la Plataforma implica ningún tipo de retirada, transmisión, licencia o cesión total ni parcial de los referidos derechos, salvo que se establezca expresamente y por escrito lo contrario.`,
        list3: `Quedan reservados todos los derechos de propiedad intelectual e industrial sobre los contenidos y/o servicios de la Plataforma y, en particular, queda prohibido modificarlos, copiarlos, reproducirlos, comunicarlos públicamente, transformarlos o distribuirlos, por cualquier medio o en cualquier formato , incluyéndose en ellos todo o parte de los contenidos para fines públicos o comerciales, salvo que se obtenga la autorización previa, expresa y por escrito de los respectivos titulares.`,
        list4: `El usuario que contravenga estas limitaciones y prohibiciones reconoce que asume la responsabilidad exclusiva, liberando de cualquier responsabilidad a Multiassistance, o a cualquier otro tercero que pueda verse afectado por la actuación del usuario.`
      },
      paragraph6: {
        title: `EXCLUSIÓN DE GARANTÍAS Y RESPONSABILIDAD.`,
        list1: `Multiassistance adoptará diversas medidas para proteger la Plataforma y los contenidos contra ataques informáticos de terceros. En cualquier caso, es importante que los usuarios sean responsables de tomar todas las medidas técnicas adecuadas para controlar razonablemente las amenazas a las que están expuestos, incluida la actualización de los sistemas para la detección de software malicioso, como virus, troyanos, etc. así como parches de seguridad para los navegadores afectados.`,
        list2: `El usuario es responsable de mantener seguras sus claves de acceso y deberá evitar su uso por parte de terceros no autorizados y adoptar las medidas de seguridad necesarias para mantener la confidencialidad de los sistemas o claves de acceso y verificación establecidos en relación con la Plataforma. Multiassistance declina toda responsabilidad en el caso de negligencia, imprudencia o mal uso por parte del usuario o de un tercero no autorizado y, en ningún caso, responderá de los daños y perjuicios que pudieran derivarse de dicho acceso no autorizado.`,
        list3: `Multiassistance se reserva el derecho a suspender, sin previo aviso, el acceso a los usuarios que, a su criterio, incumplan las normas de uso de la Plataforma y, además, a ejercitar las medidas legales pertinentes, sin que ello no genera ningún derecho de indemnización en beneficio del usuario que haya podido resultar afectado.`,
        list4: `Multiassistance declina toda responsabilidad derivada de los daños y perjuicios de cualquier tipo que puedan derivarse de la utilización de los servicios y contenidos por parte de los usuarios, o que puedan derivarse de la falta de información, exactitud o veracidad que estos faciliten como parte de la Plataforma y el Servicio. En ningún caso Multiassistance será responsable del uso que los usuarios y/o terceros hagan de la Plataforma, así como de los daños y perjuicios que pudieran derivarse del mismo.`
      },
      paragraph7: {
        title: `DE LA MODIFICACIÓN DE LOS AVISOS LEGALES`,
        list1: `Multiassistance se reserva el derecho a modificar la información contenida en estos avisos legales, con el objeto de adaptarlos a futuras novedades legislativas, doctrinales o jurisprudenciales que surjan de la aplicación, ya sea de carácter técnico, operativo, comercial, societario y empresarial, previa y notificación razonable a los usuarios de los cambios que se produzcan lo antes posible. En cualquier caso, se recomienda, cada vez que acceda a la Plataforma, leer atentamente los avisos legales.`,
        list2: `En caso de duda relativa a estos avisos legales, el usuario podrá ponerse en contacto con Multiassistance por correo electrónico en la siguiente dirección de correo electrónico: info@multiasistencia.com`
      }
    },
    bpce: {
      general: {
        title: 'Uso de cookies',
        paragraph1: 'Este sitio web utiliza cookies técnicas para garantizar su correcto funcionamiento.',
        title2: 'Política de Privacidad',
        paragraph2: 'Multiassistance procesará sus datos personales para la gestión de su siniestro. En cualquier momento, podrá ejercer su derecho de acceso, rectificación, eliminación, así como los previstos por el RGPD. Para más información, consulte ',
        policyText: 'nuestra política de privacidad completa.',
        acceptText: 'He leído y acepto la ',
        privacyText: 'Política de Privacidad'
      },
      privacy: {
        title: 'Política de Privacidad',
        paragraph1: 'MULTIASSISTANCE, S.A., con domicilio en 19 rue Emmy Noether, 93400 Saint-Ouen-sur-Seine (Francia), inscrita en el Registro Mercantil de Bobigny con el número 413 114 901, le informa en su calidad de responsable del tratamiento que, a través de BillMA, trataremos sus datos personales (datos de identificación, datos relacionados con su seguro, datos de contacto y datos financieros vinculados a su seguro) para gestionar y revisar el presupuesto asociado a su siniestro, en base a la ejecución de su contrato de seguro. A este respecto, le informamos que sus datos nos han sido comunicados por BPCE Assurances IARD.',
        paragraph2: 'Estos datos se conservarán durante el tiempo estrictamente necesario para la consecución del propósito indicado y el cumplimiento de las obligaciones legales aplicables.',
        paragraph3: 'Asimismo, le informamos que sus datos no serán cedidos a terceros, salvo obligación legal.',
        paragraph4: 'Finalmente, le informamos que puede ejercer sus derechos de acceso, rectificación, supresión, limitación del tratamiento, portabilidad de datos u oposición enviando un correo electrónico a ',
        paragraph5: 'Si considera que sus derechos no han sido respetados correctamente, puede presentar una reclamación ante la Comisión Nacional de Informática y Libertades (',
        paragraph6: ') No obstante, le recomendamos que antes de presentar una queja o reclamación, se comunique con nuestro Delegado de Protección de Datos (',
        paragraph7: ') para analizar la situación concreta y, si es necesario, buscar una solución eficaz y amistosa.'
      }
    }

  },
  summary: {
    title: 'Síntesis',
    billma: {
      solution: 'Solución: Elegir mi propio artesano',
      text1: 'Su presupuesto ha sido aceptado.',
      text2: 'Recibirá, en el menor tiempo posible, un primer pago del 50% del monto con IVA para que pueda iniciar los trabajos con su artesano.',
      text3: 'El saldo se le abonará tras la presentación de la factura que deberá enviarnos desde su Espacio Cliente o su aplicación Mon Allianz móvil.'
    },
    immobilier: {
      title: 'Daños inmobiliarios',
      ren: {
        compensation: 'Cita seleccionada',
        details: 'Detalles del funcionamiento',
        modal: {
          title: 'Detalles del funcionamiento',
          subtitle: 'La indemnización que recibirá por sus daños mobiliarios depende de:',
          list1: 'Si elige la reparación a cargo de un artesano homologado, seleccionará la fecha y hora de la primera cita con el artesano según los horarios disponibles que se le propongan. Este será el encargado de llevar a cabo todos los trabajos relacionados con sus daños inmobiliarios, coordinándose con usted si se necesitan varias intervenciones.',
          list2: 'Allianz cubrirá directamente las reparaciones, excepto el posible deducible que será su responsabilidad y deberá ser pagado directamente al artesano al finalizar su servicio.',
          confirm: 'Aceptar'
        },
        solution: 'Solution : Elegir un profesional autorizado por Allianz',
        text1: 'El profesional se pondrá en contacto con usted en un plazo de 48h* para confirmar la fecha y la hora de su cita.',
        text2: 'Un asesor del servicio de reparaciones de Allianz también está disponible para cualquier consulta relacionada con su expediente.',
        phoneText: '(precio de una llamada local)'
      },
      franchise: {
        title: 'Deducible',
        subtitle: 'Deducible a cargo del cliente'
      },
      billma: 'Presupuesto aceptado',
      gag: {
        compensation: 'Detalle de su indemnización',
        indemnisation: 'Monto total',
        details: 'Daños declarados',
        dommages: 'Daños internos',
        calcule: '¿Cómo se calcula esta indemnización?',
        modal: {
          title: '¿Cómo se calcula esta indemnización?',
          subtitle: 'La indemnización de mutuo acuerdo que recibirá por sus daños inmobiliarios se calcula en base al costo total de reparación nueva de los daños inmobiliarios. Este costo incluye materiales, alquiler de herramientas y una compensación por el tiempo empleado. Si acepta esta indemnización, se deducirá de la base total cualquier deducible que corresponda a su cargo.',
          confirm: 'Aceptar'
        },
        franchise: {
          title: 'Deducible',
          subtitle: 'Deducible a cargo del cliente'
        },
        solution: 'Solución: Realizar los trabajos yo mismo'
      }
    },
    mobilier: {
      title: 'Daños mobiliarios',
      subtitle: 'Detalle de su indemnización',
      indemnisation: 'Monto total',
      details: 'Daños declarados',
      total: 'Base de indemnización total',
      solution: 'Solución: Recibir una indemnización inmediata',
      description: 'Recibirá, a la brevedad, el pago de su indemnización que le permitirá reemplazar su mobiliario dañado.'
    },
    frais: {
      title: 'Gastos relacionados con el siniestro',
      recherche: 'Búsqueda de fugas',
      deplacement: 'Movimiento de mobiliario',
      mise: 'Seguridad',
      provisorie: 'Reparación provisional',
      gag: {
        title: 'Deducible',
        subtitle: 'Deducible a cargo del cliente',
        total: 'Indemnización total'
      },
      solution: 'Solución: Recibir un reembolso con justificante',
      description: 'Para obtener el reembolso de los gastos incurridos lo antes posible, envíenos sus justificantes directamente desde su Espacio Cliente, sección "Mis gestiones".'
    },
    confirm: 'Aceptar y finalizar'
  },
  textDescriptionError:
    'Por favor, complete la descripción de los daños antes de continuar',
  stepper: {
    step3: 'Elección de la solución de indemnización',
    step4: 'Síntesis'
  }
}
